export default function transformBillerInputWithKey(data =[], value) {
    const selectedData = data?.find(item => item.name === value);
    if (selectedData) {
        return {
            label: capitalizeFirstLetter(selectedData.name),
            value: selectedData.name,
            image: selectedData.image
        };
    }
    return null;
};

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};


// transformBillerInputWithKey